module.exports = __webpack_public_path__ + "fonts/effect-fatigue-c7e8bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-fatigue.svg
// module id = 752
// module chunks = 0